/**
 * @deprecated This page is deprecated and will be removed in the next version
 * Use /login instead - single login page for all roles (ADMIN, MEMBER)
 * This file is kept for backward compatibility only
 */

import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const AdminLogin: React.FC = () => {
  // Redirect to main login page
  useEffect(() => {
    console.warn('AdminLogin is deprecated. Redirecting to /login');
  }, []);

  return <Navigate to="/login" replace />;
};

export default AdminLogin;